module.exports = __webpack_public_path__ + "static/media/xLarge.0a311554.png";